export enum Role {
    Admin = 'Admin',
    CompanyUser = 'CompanyUser'
}
